module.exports = __webpack_public_path__ + "static/media/rasapi32_103.e95a9b19.ico";